import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    commissionPlanDocuments: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const commissionPlanDocumentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.COMMISSIONPLANDOCUMENT_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.COMMISSIONPLANDOCUMENT_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.COMMISSIONPLANDOCUMENT_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        default: {
            return state;
        }
    }
};

export default commissionPlanDocumentsReducer;